import React, { useState } from 'react';
import {
	autoUpdate,
	flip,
	FloatingPortal,
	offset,
	shift,
	useFloating,
	useHover,
	useInteractions
} from '@floating-ui/react';
import './AtsTooltip.sass';

export default function AtsTooltip({
	text,
	placement = 'right',
	className,
	children
}) {
	const [isOpen, setIsOpen] = useState(false);
	const { refs, floatingStyles, context } = useFloating({
		open: isOpen,
		onOpenChange: setIsOpen,
		placement,
		middleware: [offset(8), flip(), shift({ padding: 8 })],
		whileElementsMounted: autoUpdate
	});

	const hover = useHover(context, {
		delay: { open: 80, close: 80 }
	});
	const { getReferenceProps, getFloatingProps } = useInteractions([hover]);
	const triggerClassName = `ats-tooltip-trigger${className ? ` ${className}` : ''}`;

	if (!text) {
		return <span className={triggerClassName}>{children}</span>;
	}

	return (
		<>
			<span
				ref={refs.setReference}
				className={triggerClassName}
				{...getReferenceProps()}>
				{children}
			</span>
			{isOpen && (
				<FloatingPortal>
					<div
						ref={refs.setFloating}
						style={floatingStyles}
						className="ats-tooltip"
						role="tooltip"
						{...getFloatingProps()}>
						{text}
					</div>
				</FloatingPortal>
			)}
		</>
	);
}
